<template>
  <div class="apply_wrapper" v-if="getItem">
    <div class="page page1">
      <div class="top">202006 通路版</div>
      <h1>【指示付款同意暨約定書】</h1>
      <div class="topTit">立書人雙方因本指示付款同意暨約定書(以下簡稱本約定書)第一項之買賣，經雙方個別商議，同意履行下列條款，特立本約定書為證。</div>
      <ul>
        <li>
          <span class="tit">一、</span>立書人間購買如下標的：
          <br />
          <div class="itemDetail">
            名稱：
            <span class="pro pro_1">{{getItem.productName}}</span>；
            型號：
            <span class="pro pro_2">{{getItem.carId}}</span>；
            數量：
            <span class="pro pro_3">乙</span>；
            價金總額：
            <span class="pro pro_mn"></span>元。
          </div>
        </li>
        <li>
          <span class="tit">二、</span>撥款對象：<br/>
          立書人雙方同意由&nbsp;貴公司撥付如下所示之帳戶，並確認撥付資料正確無誤。
          <div class="tableBox">
            <span class="tableTit">（一）</span>
            <table class="table">
              <tr>
                <th width="47px">銀行</th>
                <td width="215px">{{getItem.bankName}}</td>
                <th width="47px">分行</th>
                <td>{{getItem.bankSubName}}</td>
              </tr>
              <tr>
                <th>戶名</th>
                <td>{{getName}}</td>
                <th>帳號</th>
                <td>{{getItem.bankAccount}}</td>
              </tr>
              <tr>
                <th>金額</th>
                <td colspan="3"></td>
              </tr>
            </table>
            <span class="tableTit2">（二）</span>
            <table class="table">
              <tr>
                <th width="47px">銀行</th>
                <td width="215px"></td>
                <th width="47px">分行</th>
                <td></td>
              </tr>
              <tr>
                <th>戶名</th>
                <td v-if="getItem.vendor.productId === '2'">{{getItem.customer.name}}</td>
                <td v-else></td>
                <th>帳號</th>
                <td></td>
              </tr>
              <tr>
                <th>金額</th>
                <td colspan="3"></td>
              </tr>
            </table>
          </div>
          <!--tableBox-->
        </li>
        <li>
          <span class="tit">三、</span>立書人雙方確認買賣標的物已交付，數量暨品質經驗收無誤，若有發生任何糾紛，願自行負完全責任，與&nbsp;貴公司無涉。
          <br />此致
        </li>
      </ul>
      <div class="sign">
        <div class="signCom">裕富數位資融股份有限公司</div>
        <div class="signName">
          立書人
          <span>(買受人即申請人)：</span>
        </div>
        <div class="signID">身分證字號：{{getItem.customer.memberId}}</div>
        <div class="signADD">戶籍地址：{{getItem.customer.home.residenceAddress}}</div>
        <div class="signPhone">連絡電話：{{getItem.customer.cellphone}}</div>
        <div class="signName2">
          立書人
          <span>(出賣人即債權讓與人)：</span>
        </div>
      </div>
      <!--sign-->
      <div class="date">
        中華民國<span class="d d1">&nbsp;</span>年<span class="d d2">&nbsp;</span>月<span class="d d3">&nbsp;</span>日
      </div>
    </div>
    <!--page1-->
  </div>
  <!--wrapper-->
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ApplyPage",
  data() {
    return {
      item: null,
      status: false,
      now: new Date(),
    };
  },
  created() {
    const caseId = this.$route.query.caseId;
    this.status = parseInt(this.$route.query.caseCategory, 10);
    if (caseId) {
      this.fetchFinanceCreditInfo({ caseId }).then((results) => {
        if (results.length) {
          this.item = results[0];
          if (this.item.vendor.productId === "1") {
            // 借新還舊
            this.item.bankName = "華南銀行";
            this.item.bankSubName = "敦化分行";
            this.item.customer.name = "裕富數位資融股份有限公司";
            this.item.bankAccount = "130100030060";
          } else if (this.item.vendor.productId === "2") {
            // 他行代償
            this.item.bankName = this.item.beforeBankName;
            this.item.name = this.item.beforeName;
            this.item.bankSubName = this.item.beforeBankSubName;
            this.item.bankAccount = this.item.beforeBankAccount;
          }
          console.log(`fetchFinanceCreditInfo ${JSON.stringify(this.item)}`);
        }
      });
    }
  },
  computed: {
    ...mapGetters(["getUserInfo"]),
    getItem() {
      return this.item;
    },
    getCreateDate() {
      return new Date(this.getItem.createDate);
    },
    getName() {
      if (this.getItem.vendor.productId === "2") {
        return this.getItem.name;
      }
      return this.getItem.customer.name;
    },
  },
  methods: {
    ...mapActions(["fetchFinanceCreditInfo"]),
  },
};
</script>

<style scoped src="../../assets/css/apply_page.css">
</style>



// WEBPACK FOOTER //
// src/pages/web/ApplyPage.vue